import React, { FC } from 'react';
import { LandscapeProjectsAddProjectsGeneralInformationImageGalleryTemplate } from '../../templates';

interface LandscapeProjectsAddProjectsGeneralInformationImageGalleryPageProps {}

const LandscapeProjectsAddProjectsGeneralInformationImageGalleryPage: FC<
  LandscapeProjectsAddProjectsGeneralInformationImageGalleryPageProps
> = () => {
  return <LandscapeProjectsAddProjectsGeneralInformationImageGalleryTemplate />;
};

export default LandscapeProjectsAddProjectsGeneralInformationImageGalleryPage;
